import React from "react";

import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import { MixPanelTrackedLink } from "../MixPaneTrackedLink";

export default function ({ details, showDivider = true }) {
    return <React.Fragment>
        <ListItem disablePadding>
            <MixPanelTrackedLink
                gtmEvent={details.gtmEvent || null}
                label={details.label}
                href={details.url || "#"}
                onClick={!details.url ? details.onClick : null}
                type="listItemButton"
                context="Links on header"
            >
                <ListItemIcon>
                    {details.icon}
                </ListItemIcon>
                <ListItemText primary={details.label} />
            </MixPanelTrackedLink>
        </ListItem>
        {showDivider ? <Divider sx={{ m: 0 }} /> : null}
    </React.Fragment>
}